import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Panel, PanelBody } from "../components/panel/panel.jsx";
import { Api } from "../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";
import Swal from "sweetalert2";
// import Select from "react-select";
//import Button from "@material-ui/core/Button";

const hiddenFileInput = React.createRef(null);

class VeterinarianInscription extends React.Component {
  constructor(props) {
    super(props);

    if (props.auth.user.name === undefined) {
      this.props.history.push("login");
    }

    this.state = {
      nivelUsuario: localStorage.nivel_actual,
      tramite_id: "5",
      accion_id: "",
      disabled: true,
      solicitud_id: "",
      medico_veterinario: {
        id: "",
        nombres: "",
        apellido_paterno: "",
        apellido_materno: "",
        telefono: "",
        codigo_ipsa: "",
      },
      options_activities: [],
      options_action: [],
      establecimiento: {
        id: "",
        razon_social: "",
        guid: "",
      },
      establecimientos: [],
      tipo_documento_id: "",
      documentos_medico_veterinario: [],
      docsRequired: [],
      document_type_temp: 0,
      telefono: "",
      maxLength: 8,
      options_documents: [],
      recs: 0,
      val_codigo_ipsa: "",
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleRegister = this.handleRegister.bind(this);

    this.handleTipoEstablecimiento = this.handleTipoEstablecimiento.bind(this);
    this.handleGuidEstablecimiento = this.handleGuidEstablecimiento.bind(this);
    this.handleExisteEstablecimiento =
      this.handleExisteEstablecimiento.bind(this);

    this.addEstablecimientos = this.addEstablecimientos.bind(this);
    this.removeEstablecimientos = this.removeEstablecimientos.bind(this);

    this.mensajeError = this.mensajeError.bind(this);
    this.validarFormMedico = this.validarFormMedico.bind(this);
    this.validarCodigoIpsa = this.validarCodigoIpsa.bind(this);

    this.handleTipoDocumento = this.handleTipoDocumento.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleTipoAccion = this.handleTipoAccion.bind(this);
    this.handleCorrection = this.handleCorrection.bind(this);
  }

  forma_MedicoVeterinario = "";

  componentDidMount() {
    //let medico = document.querySelector("#f_MedicoVeterinario");
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    this.forma_MedicoVeterinario = Api.form({
      target: "#f_MedicoVeterinario",
      class: "",
      elementClass: "form-control",
      elements: [
        {
          select: {
            type: "text",
            name: "accion_id",
            label: "Tipo solicitud: <span class='text-danger'> *</span>",
            cols: 12,
          },
        },
        {
          input: {
            type: "text",
            name: "nombre",
            label: "Nombre:  <span class='text-danger'> *</span>",
            cols: 6,
            hide: true,
          },
        },
        {
          input: {
            type: "text",
            name: "apellido_paterno",
            label: "Apellido paterno: <span class='text-danger'> *</span>",
            cols: 3,
            hide: true,
          },
        },
        {
          input: {
            type: "text",
            name: "apellido_materno",
            label: "Apellido materno: <span class='text-danger'> *</span>",
            cols: 3,
            hide: true,
          },
        },
        {
          input: {
            type: "text",
            name: "direccion",
            label: "Dirección: <span class='text-danger'> *</span>",
            cols: 12,
          },
        },
        {
          input: {
            type: "number",
            name: "telefono_celular",
            label: "Teléfono: <span class='text-danger'> *</span>",
            cols: 6,
            hide: true,
          },
        },
        {
          input: {
            type: "text",
            name: "codigo_ipsa",
            label: "Código IPSA: <span class='text-danger'> *</span>",
            cols: 11,
          },
        },
        {
          button: {
            name: "validar_CodigoIpsa",
            class: "form-control btn btn-light",
            text: "",
            value: "0",
            cols: 1,
            icon: "fa fa-th",
            click: (me, data) => {
              this.validarCodigoIpsa(
                this.forma_MedicoVeterinario.data().codigo_ipsa
              );
            },
          },
        },
        {
          input: {
            type: "text",
            name: "razon_social",
            label: "Establecimiento:",
            cols: 6,
          },
        },
        {
          input: {
            type: "text",
            name: "guid",
            label: "GUID",
            maxLength: "4",
            cols: 5,
          },
        },
        {
          button: {
            name: "validar_guid",
            class: "form-control btn btn-light",
            text: "",
            value: "0",
            cols: 1,
            icon: "fa fa-th",
            click: (me, data) => {
              this.handleGuidEstablecimiento();
              let valido =
                this.forma_MedicoVeterinario.querySelector(
                  "#validar_guid"
                ).value;

              if (valido === "1") {
                this.addEstablecimientos(this.state.establecimiento);
                this.forma_MedicoVeterinario.querySelector(
                  "#validar_guid"
                ).value = "0";
              }
            },
          },
        },
      ],
      onchange: (me, data, serial) => {
        switch (me.name) {
          case "guid":
            this.forma_MedicoVeterinario.querySelector("#guid").value =
              me.value.toUpperCase();
            break;

          case "telefono_celular":
            let t =
              this.forma_MedicoVeterinario.querySelector(
                "#telefono_celular"
              ).value;
            if (t.length > this.state.maxLength) {
              this.mensajeError("Error", "Introducir teléfono de 8 digitos");
            }
            break;

          case "nombre":
            this.forma_MedicoVeterinario.querySelector("#nombre").value =
              me.value.toUpperCase();
            break;

          case "apellido_paterno":
            this.forma_MedicoVeterinario.querySelector(
              "#apellido_paterno"
            ).value = me.value.toUpperCase();
            break;

          case "apellido_materno":
            this.forma_MedicoVeterinario.querySelector(
              "#apellido_materno"
            ).value = me.value.toUpperCase();
            break;

          case "direccion":
            this.forma_MedicoVeterinario.querySelector("#direccion").value =
              me.value.toUpperCase();
            break;

          case "razon_social":
            this.forma_MedicoVeterinario.querySelector("#razon_social").value =
              me.value.toUpperCase();
            break;

          case "accion_id":
            let accion_id = me.value;
            this.setState({ accion_id: accion_id });
            this.handleTipoAccion(accion_id);
            break;
          default:
            break;
        }
      },
      render: (me) => {
        Api.loading(true);

        Api.fetch("cat/getDocsPorTramite?tramite_id=5&accion_id=1").then(
          (data) => {
            if (data) {
              this.setState({ options_documents: data });
            }
          }
        );

        Api.fetch("cat/getDocsPorTramite?tramite_id=5&accion_id=1").then(
          (data) => {
            if (data) {
              this.setState({ docsRequired: data });
            }
          }
        );

        Api.fetch("cat/getActionType?tramite_id=5").then((data) => {
          if (data) {
            this.setState({ options_action: data });

            let comboAccion = `<option value="">Seleccione tipo solicitud</option>`;

            for (let a in data) {
              comboAccion += `<option value="${data[a].value}">${data[a].label}</option>`;
            }
            me.querySelector("#accion_id").innerHTML = comboAccion;

            me.querySelector("#accion_id").value = "";
          }
        });

        let direccion = "";
        let materno = "";

        Api.fetch("app/autoRellenarPersona").then((p) => {
          if (p.direccion) {
            direccion = p.direccion.toUpperCase();
          }

          if (p.materno) {
            materno = p.materno.toUpperCase();
          }
          me.querySelector("#nombre").value = p.nombres.toUpperCase();
          me.querySelector("#apellido_paterno").value =
            p.apellido_paterno.toUpperCase();
          me.querySelector("#apellido_materno").value = materno;
          me.querySelector("#telefono_celular").value =
            p.telefono_celular.toUpperCase();
          me.querySelector("#direccion").value = direccion;

          this.setState({ val_codigo_ipsa: p.codigo_ipsa });
          Api.loading(false);
        });
      },
    });

    this.btn_generar = Api.form({
      target: "#btn_generar",
      class: "",
      elementClass: "form-control",
      elements: [
        {
          button: {
            name: "btn_generarSol",
            cols: 12,
            text: "Generar",
            click: (me, data) => {
              let obj_enviar = {};
              let apellido_materno = "";
              if (
                this.forma_MedicoVeterinario.data().apellido_materno !==
                undefined
              ) {
                apellido_materno = this.forma_MedicoVeterinario
                  .data()
                  .apellido_materno.toUpperCase();
              }

              if (this.state.accion_id === "1") {
                obj_enviar = {
                  tramite_id: this.state.tramite_id,
                  accion_id: this.forma_MedicoVeterinario.data().accion_id,
                  nombre: this.forma_MedicoVeterinario
                    .data()
                    .nombre.toUpperCase(),
                  apellido_paterno: this.forma_MedicoVeterinario
                    .data()
                    .apellido_paterno.toUpperCase(),
                  apellido_materno: apellido_materno,
                  direccion: this.forma_MedicoVeterinario.data().direccion,
                  telefono:
                    this.forma_MedicoVeterinario.data().telefono_celular,
                  codigo_ipsa: this.forma_MedicoVeterinario.data().codigo_ipsa,
                  establecimientos: this.state.establecimientos,
                  documentos: this.state.documentos_medico_veterinario,
                };
              } else {
                obj_enviar = {
                  tramite_id: this.state.tramite_id,
                  accion_id: this.forma_MedicoVeterinario.data().accion_id,
                  nombre: this.state.medico_veterinario.nombres.toUpperCase(),
                  apellido_paterno:
                    this.state.medico_veterinario.apellido_paterno.toUpperCase(),
                  apellido_materno: apellido_materno,
                  direccion: this.forma_MedicoVeterinario.data().direccion,
                  telefono: this.state.medico_veterinario.telefono,
                  codigo_ipsa: this.state.medico_veterinario.codigo_ipsa,
                  establecimientos: this.state.establecimientos,
                  documentos: this.state.documentos_medico_veterinario,
                };
              }
              this.validarFormMedico(obj_enviar);
            },
            render: (me, data) => {
              if (this.forma_MedicoVeterinario.data().accion_id === "3003") {
                me.classList = "form-control btn btn-lg btn-warning";
                me.innerHTML = "Editar";
              } else {
                me.classList = "form-control btn btn-lg btn-success";
                me.text = "Generar";
              }
            },
          },
        },
      ],
    });
  }

  handleTipoAccion(e) {
    let docs = this.state.docsRequired;

    if (e === "3003") {
      Api.fetch("app/getMVCorreccion?tramite_id=" + this.state.tramite_id).then(
        (r) => {
          this.forma_MedicoVeterinario.querySelector("#codigo_ipsa").value =
            r.codigo_ipsa;

          for (let d in docs) {
            for (let rd in r.documentos) {
              if (r.documentos[rd].type === docs[d].tipo_documento_id) {
                docs[d].status = 3;
              }
            }
          }

          this.setState({
            solicitud_id: r.id,
            medico_veterinario: r.medico_veterinario,
            establecimientos: r.establecimientos,
            documentos_medico_veterinario: r.documentos,
            docsRequired: docs,
            recs: document.querySelectorAll("i.text-success").length,
          });

          this.forma_MedicoVeterinario.querySelector("#nombre").disabled = true;
          this.forma_MedicoVeterinario.querySelector(
            "#apellido_paterno"
          ).disabled = true;
          this.forma_MedicoVeterinario.querySelector(
            "#apellido_materno"
          ).disabled = true;
          this.forma_MedicoVeterinario.querySelector(
            "#codigo_ipsa"
          ).disabled = true;
          this.forma_MedicoVeterinario.querySelector(
            "#telefono_celular"
          ).disabled = true;
        }
      );
    }
  }

  handleTipoEstablecimiento(e) {
    this.setState({ tipo_establecimiento: e.target.value });
    Api.fetch(
      "app/getEstablishmentsActivities?tipo_establecimiento=" + e.target.value
    ).then((data) => {
      if (data) {
        this.setState({ options_activities: data.actividades });
      }
    });
  }

  handleSubmit(event) {
    Api.loading(true);
    Api.fetch(
      "app/checkIPSAMedicoVeterinario?codigo_ipsa=" + event.codigo_ipsa
    ).then((r) => {
      if (r === "1") {
        Swal.fire({
          title: "Atención.",
          text: "Ya existe un médico veterinario activo con el código ipsa.",
          icon: "warning",
        }).then(() => {
          Api.loading(false);
        });

        return;
      } else {
        Api.fetch(
          "app/generarSolicitudMedicoVeterinario",
          {
            tramite_id: event.tramite_id,
            direccion: event.direccion,
            codigo_ipsa: event.codigo_ipsa,
            establecimientos: event.establecimientos,
            documentos: this.state.documentos_medico_veterinario,
          },
          "POST"
        )
          .then((data) => {
            Swal.fire({
              title: "Solicitud exitosa",
              icon: "success",
              text: data.message,
            }).then(() => {
              window.location = "/tramites";
            });
          })
          .catch((error) => {
            error.json().then((message) => {
              Api.loading(false);
              Swal.fire({
                title: "Ocurrió un error al procesar la solicitud",
                icon: "error",
                text: message.message,
              });
            }); //catching errors to show notification
          });
      }
    });
  }

  handleRegister(e) {
    if (e.message !== "Su solicitud ha sido recibida exitosamente.") {
      Swal.fire({
        title: "Atención, verifique el formulario.",
        icon: "error",
        //html: tplErrors,
      });
    } else {
      Swal.fire({
        title: "Orden de pago generada",
        icon: "success",
        text: e.message,
      }).then(() => {
        window.location = "/tramites";
      });
    }
  }

  handleGuidEstablecimiento() {
    let est_state = { ...this.state.establecimiento };
    est_state["razon_social"] = this.forma_MedicoVeterinario
      .querySelector("#razon_social")
      .value.toUpperCase();
    est_state["guid"] = this.forma_MedicoVeterinario.querySelector("#guid").value;
    this.setState({ establecimiento: est_state });

    let est = {
      razon_social:
        this.forma_MedicoVeterinario.querySelector("#razon_social").value,
      guid: this.forma_MedicoVeterinario.querySelector("#guid").value,
    };

    if (est.razon_social === "" || est.guid === "") {
      this.mensajeError(
        "Error",
        "Inserte el nombre el establecimento y vuelva a introducir el guid."
      );
      return;
    }

    let valido =
      this.forma_MedicoVeterinario.querySelector("#validar_guid").value;

    if (valido === "1") {
      let adr = this.forma_MedicoVeterinario.querySelector("#validar_guid");
      adr.classList = "form-control btn btn-light";
      this.forma_MedicoVeterinario.querySelector("#validar_guid i").classList =
        "fa fa-th";
      this.forma_MedicoVeterinario.querySelector("#razon_social").classList =
        "form-control";
      this.forma_MedicoVeterinario.querySelector("#guid").classList =
        "form-control";
      return;
    }

    Api.loading(true);
    Api.fetch("app/getValidaFarmaciaEstablecimiento", est, "POST").then(
      (data) => {
        if (data) {
          this.setState({
            establecimiento: data,
          });
          this.handleExisteEstablecimiento(data);
        }
      }
    );
  }

  handleExisteEstablecimiento(data) {
    Api.loading(false);

    if (data.id) {
      let adr = this.forma_MedicoVeterinario.querySelector("#validar_guid");
      adr.classList = "form-control btn btn-success";
      this.forma_MedicoVeterinario.querySelector("#validar_guid i").classList =
        "fas fa-check";
      this.forma_MedicoVeterinario.querySelector("#validar_guid").value = "1";

      this.forma_MedicoVeterinario.querySelector("#razon_social").classList =
        "form-control blockea";
      this.forma_MedicoVeterinario.querySelector("#guid").classList =
        "form-control blockea";
    } else {
      this.mensajeError(
        "Error al ingresar el establecimiento",
        "Favor de ingresar un establecimiento con licencia vigente nacional de medicamentos veterinarios y productos afines con actividad de farmacia veterinaria."
      );
    }
  }

  addEstablecimientos(e) {
    let est = { ...this.state.establecimiento };

    let adr = this.forma_MedicoVeterinario.querySelector("#validar_guid");
    if (adr.classList === "form-control btn btn-light") {
      return;
    }

    let establecimientos = this.state.establecimientos;

    for (let re in establecimientos) {
      if (
        establecimientos[re].razon_social === est.razon_social &&
        establecimientos[re].guid === est.guid
      ) {
        this.mensajeError(
          "Atención",
          "Ya cuenta con este establecimiento en su lista."
        );
        adr.classList = "form-control btn btn-light";
        this.forma_MedicoVeterinario.querySelector(
          "#validar_guid i"
        ).classList = "fa fa-th";
        return false;
      }
    }

    establecimientos.push(est);
    this.setState({ establecimientos: establecimientos });

    adr.classList = "form-control btn btn-light";
    this.forma_MedicoVeterinario.querySelector("#validar_guid i").classList =
      "fa fa-th";

    this.forma_MedicoVeterinario.querySelector("#razon_social").value = "";
    this.forma_MedicoVeterinario.querySelector("#guid").value = "";

    let establecimiento = {
      establecimiento_id: "",
      razon_social: "",
      guid: "",
    };

    this.setState({ establecimiento: establecimiento });
  }

  removeEstablecimientos(e) {
    let lista_establecimientos = [...this.state.establecimientos];
    lista_establecimientos.splice(e.target.id, 1);
    this.setState({ establecimientos: lista_establecimientos });
  }

  mensajeError(titulo, msg) {
    Swal.fire({
      title: titulo,
      icon: "warning",
      text: msg,
    });
  }

  validarFormMedico(data) {
    let valido = 1;

    if (data.accion_id === undefined) {
      this.mensajeError("Error", "Favor de seleccionar tipo de la solicitud.");
      valido = 0;
    }

    if (data.nombre === undefined) {
      this.mensajeError("Error", "Favor de ingresar el nombre.");
      valido = 0;
    }

    if (data.apellido_paterno === undefined) {
      this.mensajeError("Error", "Favor de ingresar el apellido paterno.");
      valido = 0;
    }

    if (data.apellido_materno === undefined) {
      this.mensajeError("Error", "Favor de ingresar el apellido materno.");
      valido = 0;
    }

    if (data.direccion === undefined) {
      this.mensajeError("Error", "Favor de ingresar la dirección.");
      valido = 0;
    }

    if (
      data.telefono === undefined ||
      data.telefono.length > this.state.maxLength
    ) {
      this.mensajeError("Error", "Favor de ingresar el teléfono.");
      valido = 0;
    }

    if (data.codigo_ipsa === undefined) {
      this.mensajeError("Error", "Favor de ingresar el codigo ipsa.");
      valido = 0;
    }

    if (
      data.documentos.length === 0 ||
      data.documentos.length < this.state.docsRequired.length
    ) {
      this.mensajeError(
        "Error",
        "Favor de ingresar los documentos requeridos."
      );
      valido = 0;
    }

    if (valido) {
      if (data.accion_id === "1") {
        this.handleSubmit(data);
      } else {
        this.handleCorrection(data);
      }
    }
  }

  validarCodigoIpsa(codigo) {
    let codigo_valido = this.state.val_codigo_ipsa; //codigo que se trae del autorellenaepersona

    if (codigo === codigo_valido) {
      let adr = this.forma_MedicoVeterinario.querySelector(
        "#validar_CodigoIpsa"
      );
      adr.classList = "form-control btn btn-success";
      this.forma_MedicoVeterinario.querySelector(
        "#validar_CodigoIpsa i"
      ).classList = "fas fa-check";
      this.forma_MedicoVeterinario.querySelector("#validar_CodigoIpsa").value =
        "1";

      this.forma_MedicoVeterinario.querySelector("#codigo_ipsa").classList =
        "form-control blockea";
    } else {
      this.mensajeError(
        "Error al ingresar el código ipsa",
        "Favor de ingresar un código ipsa válido."
      );
    }
  }

  handleFile(e) {
    if (!parseInt(this.state.document_type_temp)) {
      Swal.fire({
        icon: "error",
        title: "Error...",
        text: "Debe seleccionar el tipo de documento primero.",
      });
      e.value = null;
      return;
    }

    //Si el documento ya fue adjuntado no debe de volverse a subir
    let tipo_documento =
      this.state.options_documents[parseInt(this.state.document_type_temp) - 1];
    let existeDoc = this.state.documentos_medico_veterinario.find(
      (d) => d.type === tipo_documento.id.toString()
    );

    if (existeDoc) {
      Swal.fire({
        icon: "error",
        title: "Error...",
        text: "El tipo de documento ya ha sido adjuntado.",
      });
      e.value = null;
      return;
    }

    let file = e.files;
    let validExts = ["jpg", "jpeg", "png", "pdf"];
    let ext = file[0].type.split("/")[1];

    if (validExts.includes(ext)) {
      let imgReader = new FileReader();
      imgReader.react = this;

      let _react = this.state;

      imgReader.onloadend = function () {
        let tipo = _react.options_documents[_react.document_type_temp - 1];

        let dx = {
          data: imgReader.result,
          type: tipo.id,
          tipo: tipo.descripcion,
          ext: ext,
          file: file[0].name,
          key: _react.documentos_medico_veterinario.length,
        };

        _react.documentos_medico_veterinario[
          _react.documentos_medico_veterinario.length
        ] = dx;

        // Si el documento que cargo esta como requerido marco su status
        let frecs = imgReader.react.state.docsRequired;

        for (let rec in frecs) {
          if (frecs[rec].descripcion === tipo.descripcion) {
            frecs[rec].status = 3;
            this.react.setState({
              recs: imgReader.react.state.recs + 1,
            });
          }
        }
        // Fin si el documento que cargo esta como requerido marco su status

        this.react.setState({
          documentos: _react.documentos_medico_veterinario,
        });

        this.react.setState({
          recs: document.querySelectorAll("i.text-success").length,
        });

        this.react = null;
        e.value = null;
      };
      imgReader.readAsDataURL(file[0]);
    } else {
      Swal.fire({
        icon: "error",
        title: "Error...",
        text: "Este tipo de documento no es admitido.",
      });
      e.value = null;
      return;
    }
  }

  handleTipoDocumento(e) {
    let dt = e.target.selectedIndex;

    this.setState({ document_type_temp: dt });
  }

  handleDelete(e) {
  
    Swal.fire({
      title: "Eliminar documento",
      text: "Esta acción eliminará el documento seleccionado de la carga.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      confirmButtonColor: "#4CD964",
      cancelButtonColor: "red",
      cancelButtonText: "Regresar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        let docs = [...this.state.documentos_medico_veterinario];
        // Verificamos si quitamos un documento requerido
        let frecs = [...this.state.docsRequired];
        for (let rec in frecs) {
          if (frecs[rec].descripcion === docs[e.target.id].tipo) {
            frecs[rec].status = 1;
            break;
          }
        }
        // fin verificacion

        docs.splice(e.target.id, 1);

        this.setState({
          documentos_medico_veterinario: docs,
        });

        let bandeja = document.querySelectorAll(".documentoCargado");
        for (let doc in bandeja) {
          if (!isNaN(doc)) {
            for (let rec in frecs) {
              if (
                bandeja[doc].attributes[0].value ===
                frecs[rec].tipo_documento_id
              ) {
                frecs[rec].status = 3;
              }
            }
          }
        }

        this.setState({ docsRequired: frecs });

        this.setState({
          recs: document.querySelectorAll("i.text-success").length,
        });
      }
    });
  }

  handleCorrection(event) {
    //event.preventDefault();

    Api.fetch(
      "app/updateMedVetInscription",
      {
        solicitud_id: this.state.solicitud_id,
        medico_veterinario_id: this.state.medico_veterinario.id,
        tramite_id: event.tramite_id,
        nombre: event.nombre,
        apellido_paterno: event.apellido_paterno,
        apellido_materno: event.apellido_materno,
        direccion: event.direccion,
        telefono: event.telefono,
        codigo_ipsa: event.codigo_ipsa,
        establecimientos: event.establecimientos,
        documentos: this.state.documentos_medico_veterinario,
      },
      "PUT"
    )
      .then((data) => {
        Swal.fire({
          title: "Solicitud Actualizada",
          icon: "success",
          text: "Su solicitud ha sido recibida exitosamente.",
        }).then(() => {
          window.location = "/tramites";
        });
      })
      .catch((error) => {
        error.json().then((message) => {
          Api.loading(false);
          Swal.fire({
            title: "Ocurrió un error al procesar la solicitud",
            icon: "error",
            text: message.message,
          });
        }); //catching errors to show notification
      });
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/solicitud/inscripcion-medico-veterinario">
              Solicitud
            </Link>
          </li>
          <li className="breadcrumb-item active">
            Inscripción Médico Veterinario
          </li>
        </ol>
        <h1 className="page-header">
          Solicitud de inscripción de médico veterinario
        </h1>

        <div className="row">
          <div className="col-md-12">
            <Panel>
              <PanelBody>
                <div style={{ margin: "2.8%" }}>
                  <div id="f_MedicoVeterinario"></div>

                  <hr></hr>
                  <div id="tablaEstablecimiento">
                    <div className="table-responsive">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Establecimiento </th>
                            <th>GUID </th>
                            <th> </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.establecimientos.map((est, index) => (
                            <tr key={index} id={index}>
                              <td>{est.razon_social}</td>
                              <td>{est.guid}</td>
                              <td className="text-right">
                                <button
                                  className="btn btn-warning remover-est"
                                  id={index}
                                  data-est_id={est.id}
                                  data-razon_social={est.razon_social1}
                                  data-guid={est.guid}
                                  onClick={this.removeEstablecimientos}
                                >
                                  <i
                                    className="fas fa-trash"
                                    id={index}
                                    data-est_id={est.id}
                                    data-razon_social={est.razon_social1}
                                    data-guid={est.guid}
                                    onClick={this.removeEstablecimientos}
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <hr></hr>

                    <div>
                      <h4 className="m-b-10">
                        Adjuntar documentación requerida ({this.state.recs} de{" "}
                        {this.state.docsRequired.length}):
                      </h4>{" "}
                      <h6>
                        <i>
                          *Los tipos extensión de los documentos que se admiten
                          son: ".jpg", ".jpeg", ".png" y ".pdf"{" "}
                        </i>
                      </h6>
                      <ol>
                        {this.state.docsRequired.map((doc) => (
                          <div key={doc.id}>
                            <li>
                              <i
                                className={
                                  doc.status === 3
                                    ? "far fa-check-square text-success"
                                    : "far fa-square"
                                }
                              ></i>{" "}
                              {doc.descripcion}{" "}
                            </li>
                          </div>
                        ))}
                      </ol>
                      {this.state.documentos_medico_veterinario.map(
                        (document, index) => (
                          <div
                            key={document.key}
                            data-tipo={document.type}
                            className="note note-primary documentoCargado"
                          >
                            <div className="note-icon">
                              <i
                                className={
                                  document.ext === "pdf"
                                    ? "fas fa-file-pdf"
                                    : "fas fa-file-image"
                                }
                              ></i>
                            </div>
                            <div className="note-content">
                              <h4>
                                <b>{document.tipo}</b>
                              </h4>
                              <p> {document.file} </p>
                            </div>
                            <div className="pull-right">
                              <i
                                onClick={this.handleDelete}
                                id={index}
                                className="ion ion-md-close-circle fa-2x fa-fw pull-left m-r-10 text-red"
                              ></i>
                            </div>
                          </div>
                        )
                      )}
                      {/*  <hr /> */}
                      <div className="form-group row col-md-13">
                        <label className="col-form-label col-md-10">
                          <select
                            onChange={this.handleTipoDocumento}
                            name="documento_id"
                            className="form-control m-b-5"
                          >
                            <option className="dropdown-item" value="0">
                              Seleccione tipo de documento
                            </option>

                            {this.state.options_documents.map((option) => (
                              <option
                                className="dropdown-item"
                                key={option.id}
                                value={option.id}
                              >
                                {option.descripcion}
                              </option>
                            ))}
                          </select>
                        </label>

                        <div
                          className="col-md-2"
                          style={{ marginTop: "0.55%" }}
                        >
                          <button
                            type="button"
                            className="btn btn-primary col-md-12"
                            onClick={(e) => hiddenFileInput.current.click()}
                          >
                            Seleccionar archivo
                          </button>
                          <input
                            type="file"
                            accept=".jpg,.jpeg,.png,.pdf"
                            ref={hiddenFileInput}
                            onChange={(e) => this.handleFile(e.target)}
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>
                      <hr />
                    </div>
                    <div id="btn_generar"></div>
                  </div>
                </div>
              </PanelBody>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <VeterinarianInscription auth={auth} history={history} {...props} />;
};
